import { Outlet, RouteObject } from "react-router-dom";
import WelcomePage from "../pages/welcomePage";
import { DomainProvider } from "@4uhub/lib4uhub";
import ListClassificationPage from "../pages/4uDlist/Register/ListClassification/ListClassificationPage";
import ListClassification from "../pages/4uDlist/Register/ListClassification/ListClassificationForm/ListClassification";
import ListCategoryPage from "../pages/4uDlist/Register/ListCategory/ListCategoryPage";
import ListCategory from "../pages/4uDlist/Register/ListCategory/ListCategoryForm/ListCategory";
import ListFilesPage from "../pages/4uDlist/Imports/ListFiles/ListFilesPage";
import ListFile from "../pages/4uDlist/Imports/ListFiles/ListFileForm/ListFileForm";
import ListsPage from "../pages/4uDlist/DistributionList/Lists/ListsPage";
import List from "../pages/4uDlist/DistributionList/Lists/ListForm/List";
import { ImportListContacts } from "../pages/4uDlist/Imports/ListFiles/ImportListContacts/ImportListContacts";
import ConvertToNewList from "../pages/4uDlist/Imports/ListFiles/ConvertToNewList/ConvertToNewList";
import AddToExistingList from "../pages/4uDlist/Imports/ListFiles/AddToExistingList/AddToExistingList";
import { ListContacts } from "../pages/4uDlist/DistributionList/Lists/ListContacts/ListContacts";
import ListImportAutomationPage from "../pages/4uDlist/Imports/ListImportAutomation/ListImportAutomationPage";
import ListImportAutomation from "../pages/4uDlist/Imports/ListImportAutomation/ListImportAutomationForm/ListImportAutomation";
import GenerationRulePage from "../pages/4uDlist/ListGenerator/GenerationRule/GenerationRulePage";
import GenerationRule from "../pages/4uDlist/ListGenerator/GenerationRule/GenerationRuleForm/GenerationRule";
import ListGeneration from "../pages/4uDlist/ListGenerator/ListGeneration/ListGenerationForm/ListGeneration";
import ListGenerationPage from "../pages/4uDlist/ListGenerator/ListGeneration/ListGenerationPage";

const dlistRoutes: RouteObject[] = [
  {
    index: true,
    element: <WelcomePage />,
  },
  {
    path: "register",
    element: <Outlet />,
    children: [
      {
        path: "category",
        element: (
          <DomainProvider value={{ domainName: "listcategory" }}>
            <ListCategoryPage />
          </DomainProvider>
        ),
      },
      {
        path: "category/new",
        element: (
          <DomainProvider value={{ domainName: "listcategory" }}>
            <ListCategory />
          </DomainProvider>
        ),
      },
      {
        path: "category/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "listcategory" }}>
            <ListCategory />
          </DomainProvider>
        ),
      },
      {
        path: "classification",
        element: (
          <DomainProvider value={{ domainName: "listclassification" }}>
            <ListClassificationPage />
          </DomainProvider>
        ),
      },
      {
        path: "classification/new",
        element: (
          <DomainProvider value={{ domainName: "listclassification" }}>
            <ListClassification />
          </DomainProvider>
        ),
      },
      {
        path: "classification/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "listclassification" }}>
            <ListClassification />
          </DomainProvider>
        ),
      },
    ],
  },

  {
    path: "distributionList",
    element: <Outlet />,
    children: [
      {
        path: "listControl",
        element: (
          <DomainProvider value={{ domainName: "list" }}>
            <ListsPage />
          </DomainProvider>
        ),
      },
      {
        path: "listControl/new",
        element: (
          <DomainProvider value={{ domainName: "list" }}>
            <List />
          </DomainProvider>
        ),
      },
      {
        path: "listControl/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "list" }}>
            <List />
          </DomainProvider>
        ),
      },
      {
        path: "listControl/listContacts/:id",
        element: (
          <DomainProvider value={{ domainName: "list" }}>
            <ListContacts />
          </DomainProvider>
        ),
      },
    ],
  },

  {
    path: "imports",
    element: <Outlet />,
    children: [
      {
        path: "listFiles",
        element: (
          <DomainProvider value={{ domainName: "listimportbatch" }}>
            <ListFilesPage />
          </DomainProvider>
        ),
      },
      {
        path: "listFiles/new",
        element: (
          <DomainProvider value={{ domainName: "listimportbatch" }}>
            <ListFile />
          </DomainProvider>
        ),
      },
      {
        path: "listFiles/listContacts/:id",
        element: (
          <DomainProvider value={{ domainName: "list" }}>
            <ImportListContacts />
          </DomainProvider>
        ),
      },
      {
        path: "listFiles/:listImportBatchId/convertToNewList",
        element: (
          <DomainProvider value={{ domainName: "list" }}>
            <ConvertToNewList />
          </DomainProvider>
        ),
      },
      {
        path: "listFiles/:listImportBatchId/addToList",
        element: <AddToExistingList />,
      },
      {
        path: "listImportAutomation",
        element: (
          <DomainProvider value={{ domainName: "listimportautomation" }}>
            <ListImportAutomationPage />
          </DomainProvider>
        ),
      },
      {
        path: "listImportAutomation/new",
        element: (
          <DomainProvider value={{ domainName: "listimportautomation" }}>
            <ListImportAutomation />
          </DomainProvider>
        ),
      },
      {
        path: "listImportAutomation/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "listimportautomation" }}>
            <ListImportAutomation />
          </DomainProvider>
        ),
      },
    ],
  },

  {
    path: "listGenerator",
    element: <Outlet />,
    children: [
      {
        path: "generationRules",
        element: (
          <DomainProvider
            value={{ domainName: "generationrulesdlist" }}
            actions={["Create"]}
          >
            <GenerationRulePage />
          </DomainProvider>
        ),
      },
      {
        path: "generationRules/new",
        element: (
          <DomainProvider
            value={{ domainName: "generationrulesdlist" }}
            actions={["Create"]}
          >
            <GenerationRule />
          </DomainProvider>
        ),
      },
      {
        path: "generationRules/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "generationrulesdlist" }}
            actions={["Create"]}
          >
            <GenerationRule />
          </DomainProvider>
        ),
      },
      {
        path: "generateList",
        element: (
          <DomainProvider
            value={{ domainName: "generatelistdlist" }}
            actions={["Create"]}
          >
            <ListGenerationPage />
          </DomainProvider>
        ),
      },
      {
        path: "generateList/new",
        element: (
          <DomainProvider
            value={{ domainName: "generatelistdlist" }}
            actions={["Create"]}
          >
            <ListGeneration />
          </DomainProvider>
        ),
      },
      {
        path: "generateList/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "generatelistdlist" }}
            actions={["Create"]}
          >
            <ListGeneration />
          </DomainProvider>
        ),
      },
    ],
  },
];

export default dlistRoutes;
